export const MyPage = {
  path: '/mypage',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: 'change-password',
      name: 'mypage-changePassword',
      component: () => import('pages/mypage/ChangePassword.vue'),
      meta: {
        requiresAuth: true,
        title: 'パスワード変更',
        path: '/mypage',
      },
    },
  ],
};
